import { AIWriter } from "@virtual-brain-lib/frontend-ui";

export default function Unauthorized() {
	return (
		<div className="m-auto flex h-screen max-w-lg flex-col items-center justify-center p-8 text-center text-primary">
			<AIWriter delay={100}>
				<div className="text-4xl font-bold">This link seems to be expired 💀</div>
				<div className="mt-4 text-xl">
					We couldn&apos;t load this page. Please check that this link is still available
					or regenerate a new one from your user panel.
				</div>
			</AIWriter>
		</div>
	);
}
